module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/smartcontrol-7d03f54393869427e7c345fa87471c53.jpg";